import TabPanelBatteryElectricals from '../TabPanelBatteryElectricals';
import TabPanelBatteryFirmware from '../TabPanelBatteryFirmware';
import TabPanelBatteryOverview from '../TabPanelBatteryOverview';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BatteryDrawerTabBody: FunctionComponent<Props> = ({
    activeTab,
    battery,
    className = '',
    cycleInterval,
    droneNames,
    testId = TEST_ID
}) => (
    <VerticalContainer className={`${styles.drawerBody} ${className}`} testId={testId}>
        {activeTab === 'overview' && (
            <TabPanelBatteryOverview
                battery={battery}
                cycleInterval={cycleInterval}
                droneNames={droneNames}
            />
        )}

        {activeTab === 'firmware' && <TabPanelBatteryFirmware battery={battery} />}

        {activeTab === 'electricals' && (
            <TabPanelBatteryElectricals battery={battery} cycleInterval={cycleInterval} />
        )}
    </VerticalContainer>
);

export default BatteryDrawerTabBody;
